import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SubscriptionModel } from '../../../../shared/models/subscription.model';

@Component({
    selector: 'account-subscriptions-details-basic-data',
    templateUrl: './account.subscriptions.details.basic-data.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsBasicDataComponent {
    @Input('subscription') subscription: SubscriptionModel;
    @Input('isProcessing') isProcessing: boolean;
    @Input('isActive') isActive: boolean;
    @Input('isInactive') isInactive: boolean;
    @Input('isOverdue') isOverdue: boolean;
    @Input('isPaused') isPaused: boolean;
    @Input('isFinalized') isFinalized: boolean;
    @Input('latestOrderDateSchedule') latestOrderDateSchedule: string;
    
    today: Date = new Date();
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/account/subscriptions/details/basic-data/account.subscriptions.details.basic-data.component.ts